/* eslint-disable @typescript-eslint/no-unused-vars */
import type {AppConfiguration} from "./app-configuration-types";
export const C: AppConfiguration = {
    package: 'cleanup',
    menu: 'hidden',
    profile: {
        locale: 'nl-nl',
        currency: 'EUR',

        p_name_col_name: 'Name',
        p_description_col_name: 'Description',
        searchConfiguration: 'default_p_desc',

        taxonomy_builder_only_n_cats: true,
        allowIncompleteTaxonomy: true,

        parentSupplierAltName: 'Normalized Supplier',

        enableProcChat: true,
        enableGoldenRecord: true,
        enableSavingInitiativeTracker: true,

        showCards: [
            'payment-terms-v2',
            'contract-explorer',
            'category-explore',
        ],
        hideCards: [
            'koi-key-data-facts',
            'koi-spend-concentration',
            'koi-ppv',
        ],
        untaggedCards: [
            'contract-explorer',
        ],
    },
}
